import React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Slider from 'react-slick';

const SimSlider = ({ options = {}, children }) => {
	const theme = useTheme();
	const isMd = useMediaQuery(theme.breakpoints.up('md'), {
		defaultMatches: true
	});
	const isSm = useMediaQuery(theme.breakpoints.up('sm'), {
		defaultMatches: true
	});

	const sliderOpts = {
		dots: true,
		arrows: true,
		infinite: true,
		slidesToShow: isMd ? 3 : isSm ? 2 : 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 2000,
		...options
	};

	return <Slider {...sliderOpts}>{children}</Slider>;
};

export { SimSlider };
